import { AlertTriangle, Info } from "lucide-react";

import { dataLonga, reais } from "../lib/formato";

/** Alerta vermelho de saldo negativo previsto + avisos de dado incompleto. */
export default function Avisos({ dados }) {
  const negativo = dados?.resumo?.negativo;
  const avisos = dados?.avisos || [];
  if (!negativo && !avisos.length) return null;
  return (
    <div className="space-y-2">
      {negativo && (
        <div className="rounded-2xl border border-red-500/40 bg-red-500/10 p-4 flex items-start gap-3" data-e2e="alerta-negativo">
          <AlertTriangle className="w-5 h-5 text-red-600 shrink-0 mt-0.5" />
          <div>
            <p className="font-bold text-red-700 dark:text-red-400">Em {dataLonga(negativo.data)} o saldo fica negativo: {reais(negativo.saldo)}</p>
            <p className="text-sm text-muted-foreground">Veja as contas que vencem até lá e o que vai cair na conta. Negociar um vencimento ou antecipar recebíveis resolve.</p>
          </div>
        </div>
      )}
      {!!avisos.length && (
        <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-3 space-y-1.5">
          {avisos.map((a) => <p key={a} className="flex gap-2 text-[13px] text-muted-foreground"><Info className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />{a}</p>)}
        </div>
      )}
    </div>
  );
}
